import { AdvancedFilterDataSchema } from "@redotech/redo-views-common/advanced-filters/advanced-filter-data";
import * as z from "zod";

export const getInventoryProductsCount = {
  name: "getInventoryProductsCount" as const,
  input: z.object({
    search: z.string().optional(),
    advancedFiltersData: z.array(AdvancedFilterDataSchema).optional(),
  }),
  output: z.object({
    totalCount: z.number().int(),
    hasMultipleMerchants: z.boolean(),
  }),
};
